import React from 'react'
import FieldPopover from "../../popover/popover";
import FieldDateRange_Popover from "./components/popover/popover";
import FieldDateRange_FormValueNotEmpty from "./components/form/value-not-empty";
import FieldDateRange_InlineValueNotEmpty from "./components/inline-edit/value-not-empty";
import FieldConfig from "../../../proto/field-config";
import {GROUP_DATE_TIME} from "../../../../gd/const/fields/field2-groups";
import FieldString_ManagementForm from "../../string/render/management-form";
import FieldDateRange_View from "./render/view";
import formatDate from "../../../../gd/format/date";
import {convertToMomentRangeFromValue} from "../../../../gd/convert/moment-range";
import FieldDateRange_InlineEditable from "./render/inline-editable";
import Moment from "moment";
import FieldDateRange_AutomationActionForm from "./render/automation-action";
import DatetimeUtils from "../../../../gd/utils/datetime-utils";
import normalizeDateRange from "../../../import/normalize/normalize-date-range";
import ImportFromCSVModule from "../../../../gd-modules/import-from-csv/import-from-csv-module";
import FieldDateRange_ViewSmall from "./render/view-small";
import FieldDateRange_Editable from "./render/editable/editable";
import FieldDateRange_PickerValueNotEmpty from "./components/picker/value-not-empty"
import FieldDateRange_GoalListEditable from "./render/goal-list-editable"
import FieldDateRange_GoalListView from "./render/goal-list-view"

export default class FieldDateRange extends FieldPopover {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Date range";
        this.icon               = 'i5-calendar';
        this.typeGroup          = GROUP_DATE_TIME
        this.typeDescription    = 'Start-End daterange field'
        this.clearButton        = _.get(config,'clearButton',true)

        this.maxDate            = _.get(config,'maxDate',undefined)


        this.components.PopoverMenu         = FieldDateRange_Popover
        this.components.FormValueNotEmpty   = FieldDateRange_FormValueNotEmpty
        this.components.InlineValueNotEmpty = FieldDateRange_InlineValueNotEmpty
        this.components.ValueIcon           = <span className={Classes("ui5-ico-16 m-r-10 fl-no-shrink", this.icon)}/>
        this.components.PickerValueNotEmpty         = FieldDateRange_PickerValueNotEmpty

        this.renderComponents.view          = FieldDateRange_View
        this.renderComponents.viewSmall     = FieldDateRange_ViewSmall
        this.renderComponents.inlineEditable = FieldDateRange_InlineEditable
        this.renderComponents.managementForm = FieldString_ManagementForm
        this.renderComponents.automationActionForm = FieldDateRange_AutomationActionForm

        // this.renderComponents.tableCell = FieldDateRange_TableCell
        this.renderComponents.editable = FieldDateRange_Editable
        this.renderComponents.goalListEditable      = FieldDateRange_GoalListEditable
        this.renderComponents.goalListView          = FieldDateRange_GoalListView
    }

    // we need to convert it to daterange
    getViewValue(model:any) {
        let value = _.get(model, this.fieldId, null)

        if (value) {
            value = convertToMomentRangeFromValue(value)
        }

        return value
    }

    getDisplayValue(value:any): boolean | string {
        if (!value) return false

        const dateRange = convertToMomentRangeFromValue(value)

        return "{0} - {1}".f(formatDate(dateRange.start), formatDate(dateRange.end))
    }

    sortValue(value: any, model?: any) {
        if (!value) return ''

        const dateRange = convertToMomentRangeFromValue(value)
        return "{0} - {1}".f(dateRange.start.format('X'), dateRange.end.format('X'))
    }

    get previewModel() {

        const model : any = {}
        model[this.fieldId] = {
            start   : Moment(),
            end     : Moment().add(7,'days')
        }
        return model
    }

    normalizeToCSVValue(model: any): any {
        let dateRange
        const rawValue = super.normalizeToCSVValue(model)
        if (!_.isEmpty(rawValue)) {
            dateRange = convertToMomentRangeFromValue(rawValue)
        }

        return dateRange ? "{0}/{1}".f(DatetimeUtils.momentToDate(dateRange.start), DatetimeUtils.momentToDate(dateRange.end)) : ''
    }

    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {
        return normalizeDateRange(value)
    }
}
